import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
    usuariosDisponiveis: [],
    clientesDisponiveis: [],
    imoveisDisponiveis: [],

    tiposContaDisponiveis: [],
    gruposContaDisponiveis: [],
    subgruposContaDisponiveis: [],
    planosContaDisponiveis: [],
    
    fornecedoresDisponiveis: [],
}

const mutations = {
  atualizarUsuariosDisponiveis(state, payload) {
    state.usuariosDisponiveis = payload
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload
  },
  atualizarImoveisDisponiveis(state, payload) {
    state.imoveisDisponiveis = payload
  },

  atualizarTiposConta(state, payload) {
    state.tiposContaDisponiveis = payload
  },
  atualizarGruposConta(state, payload) {
    state.gruposContaDisponiveis = payload
  },
  atualizarSubgruposConta(state, payload) {
    state.subgruposContaDisponiveis = payload
  },
  atualizarPlanosConta(state, payload) {
    state.planosContaDisponiveis = payload
  },
  atualizarFornecedores(state, payload) {
    state.fornecedoresDisponiveis = payload
  }
}

const actions = {
  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuariosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarUsuarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarUsuariosDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarImoveisDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //RelatoriosFinanceiros
  listarTipos(context, payload) {
    return axios.post(URLS.TIPO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarTiposConta', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarTipos', payload)
            }
          }).catch(error => {
            throw error
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarGrupos(context, payload) {
    return axios.post(URLS.GRUPO_PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarGruposConta', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarGrupos', payload)
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  listarSubgrupos(context, payload) {
    return axios.post(URLS.SUB_GRUPO_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarSubgruposConta', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarSubgrupos', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarPlanoConta(context, payload) {
    return axios.post(URLS.PLANO_CONTA_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarPlanosConta', response.data.lista)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarPlanoConta', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  listarFornecedores(context, payload) {
    return axios.post(URLS.FORNECEDORES_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarFornecedores', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('listarFornecedores', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gerarRelatorio(context, payload) {
    let ENDPOINT;
    // if(payload.nome == "CLIENTES_POR_CORRETOR" || payload.nome == "CONTATOS_REALIZADOS") {
    //   ENDPOINT = URLS.RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA;
    // } else {
      ENDPOINT = URLS.RELATORIOS_GERAR;
    // }

    return axios.post(ENDPOINT, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatorio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
}

export default {
  state,
  mutations,
  actions
}